import React, { useEffect, useRef } from 'react';
import mermaid from 'mermaid';
import { sanitizeMermaidSvg } from '../utils/sanitizeMermaidSvg';

// Initialize mermaid with default configuration
mermaid.initialize({
  startOnLoad: false,
  theme: 'default',
  securityLevel: 'strict',
  flowchart: {
    htmlLabels: false,
    curve: 'basis'
  }
});

const Mermaid = ({ chart }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    const renderChart = async () => {
      if (!containerRef.current) return;
      // Clear previous content
      containerRef.current.innerHTML = '';

      try {
        // Generate unique ID for this render
        const id = `mermaid-${Math.random().toString(36).substr(2, 9)}`;

        // Render the diagram
        const { svg } = await mermaid.render(id, chart);
        // The component may have unmounted (or containerRef detached) while
        // mermaid.render was in flight — writing to a null ref throws.
        if (cancelled || !containerRef.current) return;
        containerRef.current.innerHTML = sanitizeMermaidSvg(svg);
      } catch (error) {
        console.error('Error rendering mermaid chart:', error);
        if (cancelled || !containerRef.current) return;
        containerRef.current.textContent = `Error rendering chart: ${error.message}`;
      }
    };

    renderChart();

    return () => {
      cancelled = true;
    };
  }, [chart]);

  return (
    <div 
      ref={containerRef} 
      style={{ 
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px'
      }} 
    />
  );
};

export default Mermaid; 